// extracted by mini-css-extract-plugin
export default {"about":"About_about__FAXt2","section":"About_section__aCPnE","twoColumn":"About_twoColumn__bqO7I"};